import {
    INFRA_DELIVERABLE_PROJECT,
    INFRA_DELIVERABLE_PROJECT_SUCCESS,
    INFRA_DELIVERABLE_PROJECT_ERROR,
    INFRA_DELIVERABLE_PHASES,
    INFRA_DELIVERABLE_PHASES_SUCCESS,
    INFRA_DELIVERABLE_PHASES_ERROR,
    INFRA_DELIVERABLE_PHASE_SET,
    INFRA_DELIVERABLE_LIST,
    INFRA_DELIVERABLE_LIST_SUCCESS,
    INFRA_DELIVERABLE_LIST_ERROR,
    INFRA_DELIVERABLE_FREQUENCY,
    INFRA_DELIVERABLE_FREQUENCY_SUCCESS,
    INFRA_DELIVERABLE_FREQUENCY_ERROR,
    INFRA_DELIVERABLE_ACTIVITY_TYPE,
    INFRA_DELIVERABLE_ACTIVITY_TYPE_SUCCESS,
    INFRA_DELIVERABLE_ACTIVITY_TYPE_ERROR,
    INFRA_DELIVERABLE_STATUS_REVIEW,
    INFRA_DELIVERABLE_STATUS_REVIEW_SUCCESS,
    INFRA_DELIVERABLE_STATUS_REVIEW_ERROR,
    INFRA_DELIVERABLE_USERS,
    INFRA_DELIVERABLE_USERS_SUCCESS,
    INFRA_DELIVERABLE_USERS_ERROR,
    INFRA_DELIVERABLE_EDIT_MODAL_SET,
    INFRA_DELIVERABLE_EDIT_CHANGE_SET,
    INFRA_DELIVERABLE_VIEW_MODAL_SET,
    INFRA_DELIVERABLE_VIEW_SET,
    INFRA_DELIVERABLE_ADD,
    INFRA_DELIVERABLE_ADD_SUCCESS,
    INFRA_DELIVERABLE_ADD_ERROR,
    INFRA_DELIVERABLE_UPDATE,
    INFRA_DELIVERABLE_UPDATE_SUCCESS,
    INFRA_DELIVERABLE_UPDATE_ERROR,
    INFRA_ACTIVITY_LIST,
    INFRA_ACTIVITY_LIST_SUCCESS,
    INFRA_ACTIVITY_LIST_ERROR,
    INFRA_ACTIVITY_ADD_MODAL_SET,
    INFRA_ACTIVITY_ADD_CHANGE_SET,
    INFRA_ACTIVITY_EDIT_MODAL_SET,
    INFRA_ACTIVITY_EDIT_CHANGE_SET,
    INFRA_ACTIVITY_VIEW_MODAL_SET,
    INFRA_ACTIVITY_VIEW_SET,
    INFRA_ACTIVITY_ADD,
    INFRA_ACTIVITY_ADD_SUCCESS,
    INFRA_ACTIVITY_ADD_ERROR,
    INFRA_ACTIVITY_UPDATE,
    INFRA_ACTIVITY_UPDATE_SUCCESS,
    INFRA_ACTIVITY_UPDATE_ERROR,
    INFRA_ACTIVITY_CANCEL,
    INFRA_ACTIVITY_CANCEL_SUCCESS,
    INFRA_ACTIVITY_CANCEL_ERROR,
    INFRA_ACTIVITY_DOCS_MODAL_SET,
    INFRA_ACTIVITY_DOC_DELETE_SUCCESS,
} from "../../actions";

const INIT_FORM = {
    id_deliverable: null,
    id_milestone: '',
    id_status: '',
    limit_date: null,
    end_date: null,
    id_user_assign: null,
    assign_date: null,
    closed_date: null,
    notes: ''
};

const INIT_ACTIVITY_FORM = {
    id_activity: null,
    id_deliverable: null,
    id_activity_type: '',
    description: '',
    start_date: null,
    end_date: null,
    id_status: '',
    approve_date: null,
    id_user_assign: null,
    assign_date: null,
    notes: '',
    documents_view: []
};

const INIT_STATE = {
    project: { loading: false, data: null },
    phases: { loading: false, data: [] },
    activePhase: null,
    list: { loading: false, data: [] },
    frequency: { loading: false, data: [] },
    activity_type: { loading: false, data: [] },
    status_review: { loading: false, data: [] },
    users: { loading: false, data: [] },
    edit: { modal: false, loading: false, milestone: null, data: { ...INIT_FORM } },
    view: { modal: false, milestone: null, data: { ...INIT_FORM } },
    activities: {
        loading: false,
        cancel_loading: false,
        data: [],
        is_locked: false,
        id_deliverable: null,
        docs: { modal: false, data: [], id_activity: null, editable: false, id_deliverable: null },
        add: { modal: false, loading: false, data: { ...INIT_ACTIVITY_FORM } },
        edit: { modal: false, loading: false, data: { ...INIT_ACTIVITY_FORM } },
        view: { modal: false, data: { ...INIT_ACTIVITY_FORM } }
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case INFRA_DELIVERABLE_PROJECT: return { ...state, project: { ...state.project, loading: true, data: null } };
        case INFRA_DELIVERABLE_PROJECT_SUCCESS: return { ...state, project: { ...state.project, loading: false, data: action.payload } };
        case INFRA_DELIVERABLE_PROJECT_ERROR: return { ...state, project: { ...state.project, loading: false, data: null } };

        case INFRA_DELIVERABLE_PHASES: return { ...state, phases: { ...state.phases, loading: true, data: [] } };
        case INFRA_DELIVERABLE_PHASES_SUCCESS: return { ...state, phases: { ...state.phases, loading: false, data: action.payload }, activePhase: state.activePhase || (action.payload && action.payload.length > 0 ? action.payload[0].id_deliverable_phase : null) };
        case INFRA_DELIVERABLE_PHASES_ERROR: return { ...state, phases: { ...state.phases, loading: false, data: [] } };
        case INFRA_DELIVERABLE_PHASE_SET: return { ...state, activePhase: action.payload };

        case INFRA_DELIVERABLE_LIST: return { ...state, list: { ...state.list, loading: true } };
        case INFRA_DELIVERABLE_LIST_SUCCESS: return { ...state, list: { ...state.list, loading: false, data: action.payload.data } };
        case INFRA_DELIVERABLE_LIST_ERROR: return { ...state, list: { ...state.list, loading: false, data: [] } };

        case INFRA_DELIVERABLE_FREQUENCY: return { ...state, frequency: { ...state.frequency, loading: true } };
        case INFRA_DELIVERABLE_FREQUENCY_SUCCESS: return { ...state, frequency: { ...state.frequency, loading: false, data: action.payload } };
        case INFRA_DELIVERABLE_FREQUENCY_ERROR: return { ...state, frequency: { ...state.frequency, loading: false, data: [] } };
        case INFRA_DELIVERABLE_ACTIVITY_TYPE: return { ...state, activity_type: { ...state.activity_type, loading: true } };
        case INFRA_DELIVERABLE_ACTIVITY_TYPE_SUCCESS: return { ...state, activity_type: { ...state.activity_type, loading: false, data: action.payload } };
        case INFRA_DELIVERABLE_ACTIVITY_TYPE_ERROR: return { ...state, activity_type: { ...state.activity_type, loading: false, data: [] } };
        case INFRA_DELIVERABLE_STATUS_REVIEW: return { ...state, status_review: { ...state.status_review, loading: true } };
        case INFRA_DELIVERABLE_STATUS_REVIEW_SUCCESS: return { ...state, status_review: { ...state.status_review, loading: false, data: action.payload } };
        case INFRA_DELIVERABLE_STATUS_REVIEW_ERROR: return { ...state, status_review: { ...state.status_review, loading: false, data: [] } };
        case INFRA_DELIVERABLE_USERS: return { ...state, users: { ...state.users, loading: true } };
        case INFRA_DELIVERABLE_USERS_SUCCESS: return { ...state, users: { ...state.users, loading: false, data: action.payload } };
        case INFRA_DELIVERABLE_USERS_ERROR: return { ...state, users: { ...state.users, loading: false, data: [] } };

        case INFRA_DELIVERABLE_EDIT_MODAL_SET: return { ...state, activities: { ...state.activities, data: [], is_locked: false, id_deliverable: null }, edit: action.payload && action.payload.open ? { ...state.edit, modal: true, milestone: action.payload.milestone || null, data: { ...INIT_FORM, ...(action.payload.data || {}) } } : { ...state.edit, modal: false, milestone: null, data: { ...INIT_FORM } } };
        case INFRA_DELIVERABLE_EDIT_CHANGE_SET: return { ...state, edit: { ...state.edit, data: { ...state.edit.data, ...action.payload } } };

        case INFRA_DELIVERABLE_VIEW_MODAL_SET: return { ...state, activities: { ...state.activities, data: [], is_locked: false, id_deliverable: null }, view: action.payload && action.payload.open ? { ...state.view, modal: true, milestone: action.payload.milestone || null, data: { ...INIT_FORM, ...(action.payload.data || {}) } } : { ...state.view, modal: false, milestone: null, data: { ...INIT_FORM } } };
        case INFRA_DELIVERABLE_VIEW_SET: return { ...state, view: { ...state.view, data: { ...state.view.data, ...action.payload } } };

        case INFRA_DELIVERABLE_ADD: case INFRA_DELIVERABLE_UPDATE: return { ...state, edit: { ...state.edit, loading: true } };
        case INFRA_DELIVERABLE_ADD_SUCCESS: case INFRA_DELIVERABLE_UPDATE_SUCCESS: return { ...state, edit: { ...state.edit, loading: false, modal: false, milestone: null, data: { ...INIT_FORM } } };
        case INFRA_DELIVERABLE_ADD_ERROR: case INFRA_DELIVERABLE_UPDATE_ERROR: return { ...state, edit: { ...state.edit, loading: false } };

        case INFRA_ACTIVITY_LIST: return { ...state, activities: { ...state.activities, loading: true, id_deliverable: action.payload.id_deliverable } };
        case INFRA_ACTIVITY_LIST_SUCCESS: return { ...state, activities: { ...state.activities, loading: false, data: action.payload.data, is_locked: action.payload.is_locked }, edit: { ...state.edit, milestone: { ...state.edit.milestone, status: action.payload.deliverable_status }, data: { ...state.edit.data, id_status: action.payload.deliverable_status ? action.payload.deliverable_status.id_catalog_detail : state.edit.data.id_status } }, view: { ...state.view, milestone: { ...state.view.milestone, status: action.payload.deliverable_status }, data: { ...state.view.data, id_status: action.payload.deliverable_status ? action.payload.deliverable_status.id_catalog_detail : state.view.data.id_status } } };
        case INFRA_ACTIVITY_LIST_ERROR: return { ...state, activities: { ...state.activities, loading: false, data: [], is_locked: false } };

        case INFRA_ACTIVITY_ADD_MODAL_SET: return { ...state, activities: { ...state.activities, add: action.payload && action.payload.open ? { ...state.activities.add, modal: true, data: { ...INIT_ACTIVITY_FORM, ...(action.payload.data || {}) } } : { ...state.activities.add, modal: false, data: { ...INIT_ACTIVITY_FORM } } } };
        case INFRA_ACTIVITY_ADD_CHANGE_SET: return { ...state, activities: { ...state.activities, add: { ...state.activities.add, data: { ...state.activities.add.data, ...action.payload } } } };

        case INFRA_ACTIVITY_EDIT_MODAL_SET: return { ...state, activities: { ...state.activities, edit: action.payload && action.payload.open ? { ...state.activities.edit, modal: true, data: { ...INIT_ACTIVITY_FORM, ...(action.payload.data || {}) } } : { ...state.activities.edit, modal: false, data: { ...INIT_ACTIVITY_FORM } } } };
        case INFRA_ACTIVITY_EDIT_CHANGE_SET: return { ...state, activities: { ...state.activities, edit: { ...state.activities.edit, data: { ...state.activities.edit.data, ...action.payload } } } };

        case INFRA_ACTIVITY_VIEW_MODAL_SET: return { ...state, activities: { ...state.activities, view: action.payload && action.payload.open ? { ...state.activities.view, modal: true, data: { ...INIT_ACTIVITY_FORM, ...(action.payload.data || {}) } } : { ...state.activities.view, modal: false, data: { ...INIT_ACTIVITY_FORM } } } };
        case INFRA_ACTIVITY_VIEW_SET: return { ...state, activities: { ...state.activities, view: { ...state.activities.view, data: { ...state.activities.view.data, ...action.payload } } } };

        case INFRA_ACTIVITY_ADD: return { ...state, activities: { ...state.activities, add: { ...state.activities.add, loading: true } } };
        case INFRA_ACTIVITY_ADD_SUCCESS: return { ...state, activities: { ...state.activities, add: { ...state.activities.add, loading: false, modal: false, data: { ...INIT_ACTIVITY_FORM } } } };
        case INFRA_ACTIVITY_ADD_ERROR: return { ...state, activities: { ...state.activities, add: { ...state.activities.add, loading: false } } };

        case INFRA_ACTIVITY_UPDATE: return { ...state, activities: { ...state.activities, edit: { ...state.activities.edit, loading: true } } };
        case INFRA_ACTIVITY_UPDATE_SUCCESS: return { ...state, activities: { ...state.activities, edit: { ...state.activities.edit, loading: false, modal: false, data: { ...INIT_ACTIVITY_FORM } } } };
        case INFRA_ACTIVITY_UPDATE_ERROR: return { ...state, activities: { ...state.activities, edit: { ...state.activities.edit, loading: false } } };

        case INFRA_ACTIVITY_CANCEL: return { ...state, activities: { ...state.activities, cancel_loading: true } };
        case INFRA_ACTIVITY_CANCEL_SUCCESS: case INFRA_ACTIVITY_CANCEL_ERROR: return { ...state, activities: { ...state.activities, cancel_loading: false } };

        case INFRA_ACTIVITY_DOCS_MODAL_SET: return { ...state, activities: { ...state.activities, docs: action.payload && action.payload.open ? { modal: true, data: action.payload.data || [], id_activity: action.payload.id_activity || null, editable: action.payload.editable || false, id_deliverable: action.payload.id_deliverable || null } : { modal: false, data: [], id_activity: null, editable: false, id_deliverable: null } } };
        case INFRA_ACTIVITY_DOC_DELETE_SUCCESS: return { ...state, activities: { ...state.activities, docs: { ...state.activities.docs, data: state.activities.docs.data.filter((d) => d.id_activity_document !== action.payload) } } };

        default: return { ...state };
    }
};
